/**
 * TODO - EditorDataFunction type is not very good
 */
export function createStylablePanel(entry) {
    return entry;
}
//# sourceMappingURL=stylable.js.map